/* eslint-disable react/no-unknown-property */
import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';
import playIcon from '../../assets/play.png';
import playText from '../../assets/text.png';

class BigVideoNew extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        isVideoPlay: false,
        hasEverPlayed: false,
        isClosePosterImg:
            typeof navigator !== 'undefined' && navigator.userAgent.toLocaleLowerCase().includes('micromessenger'),
    };

    videoRef = React.createRef();

    operateClickHandle = (isJumpQQlink = false, isCallApp = true) => {
        console.log('operateClickHandle', isJumpQQlink, isCallApp);
        const { content = {} } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710383516',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8966',
            };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${content.base62Id}`,
        };

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo',
                pid: content._id,
                kind: 'inter_fxy13',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
                ...callImmersiveVideoConfig
            });
        }
    };

    videoClickHandle = () => {
        this.setState(
            {
                isClosePosterImg: true,
            },
            () => {
                const videoDom = this.videoRef.current;

                if (!videoDom) return;

                const { isVideoPlay } = this.state;

                if (isVideoPlay) {
                    videoDom.pause();
                    this.setState({
                        isVideoPlay: false,
                    });

                    return;
                }

                this.setState(
                    {
                        isVideoPlay: true,
                        hasEverPlayed: true,
                    },
                    () => {
                        const playResult = videoDom.play();

                        if (playResult && playResult.catch) {
                            playResult.catch(() => {
                                this.setState({
                                    isVideoPlay: false,
                                });
                            });
                        }
                    },
                );
            },
        );
    };

    renderAccountInfo = () => {
        const { content = {} } = this.props;
        const { subscribe = {} } = content;
        const logo = content.logo || subscribe.logo || '';
        const accountName = content.columnName || subscribe.originalName || subscribe.catename || '';
        const accountDesc = subscribe.description || subscribe.declare || '';
        const newsTime = (content.newsTime || content.publishedTime || '').replace(/-/g, '/');
        const callImmersiveVideoConfig = {
            docType: 'videoimmersionv2',
            pid: `https://ne883dbn.ifeng.com/shareVideoimmersionlist?id=${content.base62Id}`,
        };
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'share01',
            ...callImmersiveVideoConfig
        });

        return (
            <div className={styles.accountBox} onClick={() => this.operateClickHandle()}>
                <div className={styles.accountHeader}>
                    <div className={styles.accountMain}>
                        {logo && <img className={styles.accountAvatar} src={logo} />}
                        <div className={styles.accountTextBox}>
                            {accountName && <div className={styles.accountName}>{accountName}</div>}
                            {(newsTime || accountDesc) && (
                                <div className={styles.accountDesc}>
                                    {newsTime && <span className={styles.accountTime}>{newsTime}</span>}
                                    {accountDesc && <span className={styles.accountDescText}>{accountDesc}</span>}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className={styles.followButton}>
                        关注
                    </div>
                </div>
                {content.title && <div className={styles.videoDesc}>{content.title}</div>}
                {!content?.isVideoShare && (
                    <WxLaunchApp
                        launchType={'app'}
                        launchAppClick={() => this.operateClickHandle(false, false)}
                        schemeLink={schemeLink}
                        launchAppFail={() => this.operateClickHandle(true, true)}
                    />
                )}
            </div>
        );
    };

    render() {
        const { content = {} } = this.props;
        const { isVideoPlay, isClosePosterImg, hasEverPlayed } = this.state;
        const posterImg = content.bigPosterUrl;

        return (
            <div className={styles.bigVideoNew}>
                <div className={styles.videoWrapper} onClick={this.videoClickHandle}>
                    {isClosePosterImg && (
                        <video
                            playsinline="true"
                            x5-playsinline="true"
                            webkit-playsinline="true"
                            mediatype="video"
                            ref={this.videoRef}
                            className={styles.videoPlayer}
                            src={content.mobileUrl}
                            controls={false}
                            loop="loop"
                            preload="auto"
                            poster={posterImg}
                        />
                    )}
                    {!isClosePosterImg && posterImg && <img className={styles.posterImg} src={posterImg} />}
                    {!isVideoPlay && (
                        <div className={styles.playButtonWrap}>
                            <img className={styles.playIcon} src={playIcon} alt="" />
                            {!hasEverPlayed && (
                                <img className={styles.playText} src={playText} alt="立即播放" />
                            )}
                        </div>
                    )}
                </div>
                {this.renderAccountInfo()}
            </div>
        );
    }
}

export default errorBoundary(BigVideoNew);
